import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Events = () => {
  const navigate = useNavigate();
  const [pastEvents, setPastEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get('/api/events');
        if (response.data.status === 'success') {
          setPastEvents(response.data.data.past);
        } else {
          setError('Failed to fetch events');
        }
      } catch (err) {
        console.error("Error fetching events:", err);
        setError('Error connecting to server');
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  if (loading) return <div className="text-center py-5">Loading...</div>;
  // if (error) return <div className="text-center py-5 text-danger">{error}</div>;

  return (
    <>
      <style>
        {`
          .services-section {
            margin-bottom: 60px;
          }

          .blog-one__single {
            background: #840000;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease-in-out;
            display: flex;
            flex-direction: column;
            height: 100%;
          }

          .blog-one__single:hover {
            transform: translateY(-5px);
            box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
          }

          .blog-one__img img {
            width: 95%;
            height: 220px;
            object-fit: cover;
            margin-top: 10px;
            margin-left: 10px;
            /* margin-right in original was 100px which causes layout jump, fixed with auto */
            margin-right: 10px;
            display: block;
          }

          .blog-one__content {
            padding: 20px;
            text-align: center;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            justify-content: space-between;
          }

          .blog-one__title {
            font-size: 16px;
            font-weight: 600;
            color: #333;
            margin-bottom: 15px;
          }

          .blog-one__title a,
          .blog-one__title span {
            color: white;
            text-decoration: none;
            transition: color 0.3s;
          }

          .social-icons {
            margin-top: 15px;
          }

          .social-icons a {
            background-color: #ffd54f;
            padding: 10px;
            border-radius: 4px;
            color: white;
            font-size: 18px;
            margin: 0 8px;
            transition: color 0.3s;
            text-decoration: none;
            display: inline-block;
          }
        `}
      </style>
      <div className="breadcumb-wrapper" style={{ backgroundImage: `url('assets/img/hero/slider1.jpg')`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Past Events</h1>
          </div>
        </div>
      </div>
      <ul className="nav nav-tabs d-flex justify-content-center pt-5 pb-5">
        <li className="nav-item">
          <span className="nav-link active" style={{ cursor: 'pointer' }} onClick={() => navigate('/events')}>Past Events</span>
        </li>
        <li className="nav-item">
          <span className="nav-link" style={{ cursor: 'pointer' }} onClick={() => navigate('/upcoming-events')}>Updates & Announcements</span>
        </li>
      </ul>
      <section
        className="bg-theme overflow-hidden space overflow-hidden"
        data-bg-src="assets/img/bg/event-shape.html"
      >
        <div className="container">
          <div className="title-area style3 text-center">
            <span
              className="sub-title style text-anime-style-2"
              style={{ color: '#840000' }}
            >
              Past Events
            </span>
            <h2 className="sec-title text-white text-anime-style-3">Our Programs</h2>
          </div>

          <div className="container services-section">
            <div className="row g-4">
              {pastEvents.length > 0 ? (
                pastEvents.map((event, index) => (
                  <div
                    key={event._id}
                    className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp animated"
                    data-wow-delay={`${(index + 1) * 100}ms`}
                  >
                    <div className="blog-one__single">
                      {/* Link on Image */}
                      {(event.externalLink || event.pdfFile) ? (
                        <a href={event.pdfFile ? (window.location.hostname === 'localhost' && window.location.port !== '8000' ? `http://localhost:8000${event.pdfFile}` : event.pdfFile) : event.externalLink} target="_blank" rel="noopener noreferrer">
                          <div className="blog-one__img">
                            <img
                              src={event.image ? `${event.image}` : "/web/assets/img/event/event1.jpg"}
                              alt={event.title}
                            />
                          </div>
                        </a>
                      ) : (
                        <div className="blog-one__img">
                          <img
                            src={event.image ? `${event.image}` : "/web/assets/img/event/event1.jpg"}
                            alt={event.title}
                          />
                        </div>
                      )}

                      <div className="blog-one__content">
                        <h3 className="blog-one__title">
                          {(event.externalLink || event.pdfFile) ? (
                            <a href={event.pdfFile ? (window.location.hostname === 'localhost' && window.location.port !== '8000' ? `http://localhost:8000${event.pdfFile}` : event.pdfFile) : event.externalLink} target="_blank" rel="noopener noreferrer">
                              {event.title}
                            </a>
                          ) : (
                            <span>{event.title}</span>
                          )}
                        </h3>

                        {/* Only show View More if externalLink or pdfFile exists */}
                        {(event.externalLink || event.pdfFile) && (
                          <div className="social-icons">
                            <a
                              href={event.pdfFile ? (window.location.hostname === 'localhost' && window.location.port !== '8000' ? `http://localhost:8000${event.pdfFile}` : event.pdfFile) : event.externalLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <span className="btn-text"> view more </span>
                            </a>
                          </div>
                        )}

                        {/* Optional: Show Message excerpt if needed, but per design it seems title + link is key */}
                        {/* <p className="text-muted mt-2">{event.message}</p> */}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center text-white">No past events found.</div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Events;
